export default "__VITE_ASSET__Dmiq4q2n__"